import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
}), 'PauseSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PauseSharp.js
// module id = 5234
// module chunks = 2